import type { ProductDto } from "../types/validation";

export function getProductsCacheKey(products: ProductDto[]): string {
	return products
		.map((p) => p.id)
		.sort()
		.join("|");
}